import { render, staticRenderFns } from "./InquiryHistory.vue?vue&type=template&id=d2fe7756&scoped=true"
import script from "./InquiryHistory.vue?vue&type=script&lang=js"
export * from "./InquiryHistory.vue?vue&type=script&lang=js"
import style0 from "./InquiryHistory.vue?vue&type=style&index=0&id=d2fe7756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fe7756",
  null
  
)

export default component.exports